import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'itemFilter'
})
export class ItemFilterPipe implements PipeTransform {

  transform(items: Array<any>, name: string): Array<any> {
    return items.filter(item => item.name.toLowerCase().includes(name.toLowerCase()));
  }
}
